import { GetPaymentMethodsResponse } from "@payment-client/interfaces/PaymentApi";
import { isTurboPaymentGroup } from "./TurboPayment";

export const isTurboGpoPayload = (paymentResponse: GetPaymentMethodsResponse | null | undefined): boolean => {
    const paymentGroups = paymentResponse?.paymentGroup;

    return paymentGroups?.length === 0 || (paymentGroups?.length === 1 && isTurboPaymentGroup(paymentGroups[0]));
};
